module.exports = __webpack_public_path__ + "static/media/icon_pmh_inactive.8f473f97.svg";